import RoleSelector from "components/Player/RoleSelector";
import ConnectionStatus from "components/ConnectionStatus";
import React, { useEffect, useState } from "react";

import { useGameContext } from "GameContext";

import BackButton from "components/BackButton";
import { useNavigate } from "react-router-dom"

function RoleButton({
  role,
  changeRole,
  disabled=false,
}: {
  role: {
    role: string,
    estate: string,
    description: string,
    color: string,
  },
  changeRole: (_: string) => void;
  disabled?: boolean;
}) {
  return (
    <button className={`p-2 text-left space-y-2 border border-black ${!disabled ? "opacity-100" : "opacity-30"}`}
      style={{
        backgroundColor: role.color,
      }}
      onClick={() => changeRole(role.role)}
      disabled={disabled}
    >
      <label>{role.role}</label>
      <p>{role.description}</p>
    </button>
  )
}

const SelectRole: React.FC = () => {
  const {
    gameId,
  } = useGameContext();


  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      const message = "Are you sure you want to leave? Data may be lost";
      if (!window.confirm(message)) {
        // User pressed "Cancel" → block unload
        event.preventDefault();
        event.returnValue = "";
      }
      // If user pressed "OK", allow unload
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const navigate = useNavigate()

  useEffect(() => {
    if (!gameId) {
      navigate("/play/join");
    }
  }, [gameId])

    return (
    <div className="flex h-[100vh] w-full items-center justify-center">
      <ConnectionStatus />

      <RoleSelector
        onSelectRole={() => {
          navigate("/play/waiting");
        }}
      />


      <BackButton/>
    </div>
  )
}
export default SelectRole
